const openThemes = {
  dark: {
    defaultColor: '#424b5a',
    primaryColor: '#b2c6d0',
    secondaryColor: '#e5eff5',
    name: 'Dark',
  },
  light: {
    defaultColor: '#b0b9c9',
    primaryColor: '#dae9f1',
    secondaryColor: '#b1c1bf',
    name: 'Light',
  },
  beach: {
    defaultColor: '#E6E2AF',
    primaryColor: '#EFECCA',
    secondaryColor: '#046380',
    name: 'Beach',
  },
  summer: {
    defaultColor: '#138d90',
    primaryColor: '#001871',
    secondaryColor: '#ffb743',
    name: 'Summer',
  },
  grey: {
    defaultColor: '#f2f5f7',
    primaryColor: '#424b5a',
    secondaryColor: '#ffffff',
    name: 'Gray',
  },
  flat: {
    defaultColor: '#2C3E50',
    primaryColor: '#ECF0F1',
    secondaryColor: '#E74C3C',
    name: 'Flat UI',
  },
  purple: {
    defaultColor: '#942193',
    primaryColor: '#330066',
    secondaryColor: '#ff3366',
    name: 'Purple',
  },
  pippa: {
    defaultColor: '#F9F9F9',
    primaryColor: '#F9C132',
    secondaryColor: '#b7c1c1',
    name: 'Pippa',
  },
  acast: {
    defaultColor: '#010100',
    primaryColor: '#242A31',
    secondaryColor: '#ffd140',
    name: 'Acast',
  },
};

const openFonts = [
  {
    name: 'Open Sans',
    url: 'https://fonts.googleapis.com/css?family=Open+Sans',
    value: 'Open Sans',
  },
  {
    name: 'Roboto',
    url: 'https://fonts.googleapis.com/css?family=Roboto',
    value: 'Roboto',
  },
  { name: 'Mali', url: 'https://fonts.googleapis.com/css?family=Mali', value: 'Mali' },
  {
    name: 'Montserrat',
    url: 'https://fonts.googleapis.com/css?family=Montserrat',
    value: 'Montserrat',
  },
  { name: 'Lato', url: 'https://fonts.googleapis.com/css?family=Lato', value: 'Lato' },
  {
    name: 'Roboto Condensed',
    url: 'https://fonts.googleapis.com/css?family=Montserrat',
    value: 'Roboto Condensed',
  },
  {
    name: 'Playfair Display',
    url: 'https://fonts.googleapis.com/css?family=Playfair+Display',
    value: 'Playfair Display',
  },
  {
    name: 'Roboto Mono',
    url: 'https://fonts.googleapis.com/css?family=Roboto+Mono',
    value: 'Roboto Mono',
  },
  {
    name: 'Libre Baskerville',
    url: 'https://fonts.googleapis.com/css?family=Libre+Baskerville',
    value: 'Libre Baskerville',
  },
  {
    name: 'Roboto Slab',
    url: 'https://fonts.googleapis.com/css?family=Roboto+Slab',
    value: 'Roboto Slab',
  },
  { name: 'Georgia', url: null, value: 'Georgia' },
  { name: 'Arial', url: null, value: 'Arial' },
];

const getContrastColor = (hexColor) => {
  if (!hexColor) {
    return null;
  }
  const RGB = (pos) => parseInt(hexColor.replace('#', '').substr(pos, 2), 16);
  return RGB(0) * 299 + RGB(2) * 587 + RGB(4) * 114 >= 128000 ? '#161616' : '#F0F2F5';
};

const borderRadiusStyle = {
  square: '0px',
  radius: '5px',
  rounded: '20px',
};

export default { openThemes, openFonts, getContrastColor, borderRadiusStyle };
